import type { Poll } from '../types';

const polls: Poll[] = [];

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default polls;
